import { authAxios } from './authAxios';

// For Auth Server API Calls
export const getAPIResponse = async (url, config) => {
  return new Promise((resolve, reject) => {
    authAxios
      .get(url, config)
      .then(function (response) {
        resolve(response);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};

export const postAPIResponse = async (url, obj, config) => {
  return new Promise((resolve, reject) => {
    authAxios
      .post(url, obj, config)
      .then(function (response) {
        resolve(response);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};

export const putAPIResponse = async (url, obj, config) => {
  return new Promise((resolve, reject) => {
    authAxios
      .put(url, obj, config)
      .then(function (response) {
        resolve(response);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};

// axios expects obj to be { data: your-obj-here }
export const deleteAPIResponse = async (url, obj) => {
  const data = { data: obj };
  return new Promise((resolve, reject) => {
    authAxios
      .delete(url, data)
      .then(function (response) {
        resolve(response);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};

import { apiAxios } from './apiAxios';

// For Backend Server API Calls
export const getAPI = async (url, config) => {
  return new Promise((resolve, reject) => {
    apiAxios
      .get(url, config)
      .then(function (response) {
        resolve(response);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};

export const postAPI = async (url, obj, config) => {
  return new Promise((resolve, reject) => {
    apiAxios
      .post(url, obj, config)
      .then(function (response) {
        resolve(response);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};

export const putAPI = async (url, obj, config) => {
  return new Promise((resolve, reject) => {
    apiAxios
      .put(url, obj, config)
      .then(function (response) {
        resolve(response);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};

// axios expects obj to be { data: your-obj-here }
export const deleteAPI = async (url, obj) => {
  const data = { data: obj };
  return new Promise((resolve, reject) => {
    apiAxios
      .delete(url, data)
      .then(function (response) {
        resolve(response);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};
